import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ACTIVE_SHOP_DATA } from '@informally/frontend/active-shop';

@Injectable({ providedIn: 'root' })
export class SEOService {
  private readonly document = inject(DOCUMENT);
  private readonly shopData = inject(ACTIVE_SHOP_DATA);
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);

  async setTitle(title?: string) {
    const { tenantName } = (await this.shopData()).tenant;
    this.title.setTitle(title ? `${title} | ${tenantName}` : tenantName);
  }

  clearHreflang() {
    for (const node of Array.from<HTMLLinkElement>(this.document.head.children as never)) {
      if (node.rel === 'alternate' && typeof node.hreflang === 'string') {
        node.remove();
      }
    }
  }

  setCanonical(url: string) {
    for (const node of Array.from<HTMLLinkElement>(
      this.document.head.querySelectorAll('link[rel="canonical"]'),
    )) {
      node.remove();
    }

    const link = this.document.createElement('link');
    link.rel = 'canonical';
    link.href = url;
    this.document.head.appendChild(link);
  }

  setOpenGraphUrl(url: string) {
    this.meta.updateTag({ property: 'og:url', content: url }, "property='og:url'");
  }

  /**
   * Simple key value version of {@link Meta.updateTag}. It will refuse to allow non string values
   * get coerced into strings (e.g. `undefined`). It will remove the meta tag in this case.
   */
  updateMetaTagKv(name: string, content: string) {
    this.meta.removeTag(`name=${name}`);

    if (typeof content === 'string' && content.length) {
      this.meta.addTag({ name, content }, true);
    }
  }
}
